import { render, staticRenderFns } from "./NewForms.vue?vue&type=template&id=43031a48"
import script from "./NewForms.vue?vue&type=script&lang=js"
export * from "./NewForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports